import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ISmtpSettings } from '../models/smtp-settings';



@Component({
    selector: 'app-smtp-settings',
    templateUrl: './smtp-settings.component.html',
    styleUrls: ['./smtp-settings.component.scss'],
    standalone: false
})
export class SmtpSettingsComponent {

  @ViewChild(NgForm) form: NgForm;
  @Input() value: ISmtpSettings;
  @Output() valueChange = new EventEmitter<ISmtpSettings>();

  public static readonly DUMMY_PASSWORD = '@@@@@@@@@@@@@@@@@';

  ngAfterViewInit() {
    this.form.valueChanges.pipe(debounceTime(1)).subscribe((ev) => {
      this.valueChange.emit(this.value);
    });
  }

  get enabled() {
    return this.value != null;
  }

  set enabled(value: boolean) {
    if (value != this.enabled) {
      this.value = value === true ? { port: 25, password: '', enableSsl: false } as ISmtpSettings : null;
    }
  }

  get port() {
    return this.value?.port?.toString();
  }

  set port(value: string) {
    this.value.port = parseInt(value);
  }

  get password() {
    return this.value?.password == null ? SmtpSettingsComponent.DUMMY_PASSWORD : this.value.password;
  }

  set password(value: string) {
    if (value !== SmtpSettingsComponent.DUMMY_PASSWORD) {
      this.value.password = value;
    }
  }
}
